module.exports = __webpack_public_path__ + "img/gift.804196b0.svg";